/*
  Copy for the offer campaign, in its own dictionary rather than the app's
  lang/locales files.

  The ad has its own language, independent of the platform: the app stays
  English by default, the ad opens in Arabic, and the ad carries its own
  switcher. Wiring it through IntlMessages would tie it to the app locale,
  which is exactly what we do not want here — and keeping it self-contained
  means the whole campaign is one folder to delete when it ends.
*/

export const PROMO_LANGS = ["ar", "en"];
export const PROMO_DEFAULT_LANG = "ar";

const copy = {
  ar: {
    dir: "rtl",
    // label shown ON the switcher = the language you get by pressing it
    switchTo: "English",
    switchToShort: "EN",
    tag: "جديد",
    kicker: "خدمة جديدة",
    head1: "أعمالك.",
    head2: "مركباتك.",
    head3: "سير عملك.",
    sub: "تتبّع GPS مخصّص، مصمّم ليناسب طريقة عمل شركتك.",
    benefit1: "تنبيهات فورية للمركبات",
    benefit2: "سير عمل مخصّص لأعمالك",
    benefit3: "أتمتة مدعومة بالذكاء الاصطناعي",
    from: "ابتداءً من",
    price: "379 ر.ق",
    period: "شهرياً",
    periodShort: "شهرياً",
    barFrom: "تتبّع GPS ابتداءً من",
    barTap: "اضغط للتواصل عبر واتساب",
    cta: "راسلنا على واتساب",
    later: "ربما لاحقاً",
    validPrefix: "العرض ساري حتى",
    closeLabel: "إغلاق",
  },
  en: {
    dir: "ltr",
    switchTo: "العربية",
    switchToShort: "ع",
    tag: "NEW",
    kicker: "New service",
    head1: "Your Business.",
    head2: "Your Vehicles.",
    head3: "Your workflows.",
    sub: "Custom GPS tracking built around the way your business works.",
    benefit1: "Live vehicle alerts",
    benefit2: "Custom business workflows",
    benefit3: "AI-powered automation",
    from: "From",
    price: "QAR 379",
    period: "/ month",
    periodShort: "/mo",
    barFrom: "Custom GPS from",
    barTap: "Tap to WhatsApp us",
    cta: "WhatsApp us",
    later: "Maybe later",
    validPrefix: "Offer open till",
    closeLabel: "Dismiss offer",
  },
};

export const promoCopy = (lang) => copy[lang] || copy[PROMO_DEFAULT_LANG];

export const otherPromoLang = (lang) => (lang === "ar" ? "en" : "ar");

export default copy;
